<template>
  <span
    class="d-flex w-100 justify-content-between campaign-view-header"
    :class="{'align-items-center': !showAmountInfo}"
  >
    <div>
      {{ $t(title) }}
      <div class="custom-header-info-text mt-1" v-if="showAmountInfo">
        <h6>
        {{ $t('The amounts are in euros') }}
        </h6>
      </div>
    </div>
    <div>
      <div class="d-flex flex-row gap-2">
        <div>
          {{ $t("Member") }}:
          <MemberSelect
            v-if="!disableMemberSelect"
            :selected-member-id.sync="selectedMemberId"
            :add-empty="memberAddEmpty"
            @updateMemberId="updateMemberIdFunction"
          />
        </div>
        <div class="campaign-view-header__action" >
          <slot name="action"/>
        </div>
      </div>
    </div>
  </span>
</template>

<script>
import MemberSelect from "@/components/MemberSelect";

export default {
  name: "CampaignViewHeader",
  props: {
    disableMemberSelect: {
      type: Boolean,
      default: false,
    },
    showAmountInfo: {
      type: Boolean,
      default: false,
    },
    title: String,
    updateMemberIdFunction: Function,
    memberAddEmpty: Boolean,
    selectedMemberId: Number,
  },
  components: {
    MemberSelect,
  }
}
</script>

<style lang="scss">
.campaign-view-header {
  &__action {
    margin-top: auto;
    margin-bottom: 12px;
  }
}
</style>

